import React from 'react';

type LargeMarkdownFallbackProps = {
  /**
   * The original markdown content to display as plain text.
   */
  content: string;
};

/**
 * Render large markdown content as plain text with a subtle warning to avoid
 * heavy markdown parsing/rendering that may freeze the UI.
 *
 * Examples:
 * ```tsx
 * <LargeMarkdownFallback content={bigText} />
 * ```
 */
export const LargeMarkdownFallback: React.FC<LargeMarkdownFallbackProps> = ({
  content,
}) => {
  return (
    <div>
      <div className="mb-6 text-[11px] leading-4 text-moon-500">
        Large content — showing plain text to keep the page responsive
      </div>
      <div className="whitespace-break-spaces">{content}</div>
    </div>
  );
};
